module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIgMTBIMHY0aDR2LTJIMnYtMnpNMCAxdjNoMlYyaDJWMEgwdjF6bTE0LTFoLTR2MmgydjJoMlYwem0tMiAxMmgtMnYyaDR2LTRoLTJ2MnoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/assets/full-screen/full-screen.svg
// module id = 1683
// module chunks = 1 2 3